import type AuthUser from '~/types/authUser';

export function useAuth() {
  const { user, session, fetch } = useUserSession();

  const currentUser = computed(() => user.value as AuthUser | null);

  const isSuperadmin = computed(() => currentUser.value?.roles?.some((r) => r.roleName === 'superadmin') ?? false);

  const isCollaborator = computed(() => currentUser.value?.roles?.some((r) => r.roleName === 'collaborator') ?? false);

  const hasRoles = (roles: string[]) => currentUser.value?.roles?.some((r) => roles.includes(r.roleName)) ?? false;

  const isImpersonating = computed(() => {
    const currentSession = session.value;
    const hasRealUserId = Boolean(currentSession?.realUserId);

    return hasRealUserId;
  });

  const isCompanySuperadminEdifica = (companyId: string) => {
    return currentUser.value?.companyId === companyId && currentUser.value?.roleName === 'superadmin';
  };

  const isSuperAdmin = () => {
    return currentUser.value?.roleName === 'superadmin';
  };

  return {
    currentUser,
    isSuperadmin,
    isImpersonating,
    session,
    hasRoles,
    fetch,
    isCompanySuperadminEdifica,
    isSuperAdmin,
    isCollaborator
  };
}
